export default __webpack_public_path__ + "static/media/DiseaseM.41274769.webp";